module.exports = __webpack_public_path__ + "static/media/wallet.2ef0f16c.svg";